import { render, staticRenderFns } from "./UserSkeleton.vue?vue&type=template&id=038c90c4&scoped=true&"
import script from "./UserSkeleton.vue?vue&type=script&lang=js&"
export * from "./UserSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./UserSkeleton.vue?vue&type=style&index=0&id=038c90c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c90c4",
  null
  
)

export default component.exports